import rp751 from "./rp751";
import rp752 from "./rp752";
import rp753 from "./rp753";
import rp754 from "./rp754";
import rp755 from "./rp755";
import rp757 from "./rp757";
import rp756 from "./rp756";
import rp760 from "./rp760";
import rp768 from "./rp768";

export default {
    rp751,
    rp752,
  rp753,
  rp754,
  rp755,
  rp757,
  rp756,
  rp760,
  rp768,
};